export default __webpack_public_path__ + "static/media/us-states.21b6d5a7.geojson";